import type {Updater, Writable} from 'svelte/store';
import {writable} from 'svelte/store';
import {isEquatable} from 'shared/utils/types-utils';
import {isEqualWith} from 'lodash-es';

export function distinctStore<T>(initialValue: T): Writable<T> {
    const {subscribe, set: originalSet} = writable(initialValue);
    let currentValue = initialValue;

    const isNewValueDifferent = (newValue: T) => {
        // compare values with custom comparison for Equatable objects
        const valuesAreEqual = isEqualWith(currentValue, newValue, (val1, val2) => {
            if (isEquatable(val1)) {
                return val1.equals(val2);
            }
            if (isEquatable(val2)) {
                return val2.equals(val1);
            }
            return undefined; // else use default lodash comparator
        });

        return !valuesAreEqual;
    };

    const set = (newValue: T) => {
        if (isNewValueDifferent(newValue)) {
            currentValue = newValue;
            originalSet(newValue);
        }
    };

    return {
        subscribe,
        set,
        update: (updater: Updater<T>) => {
            const newValue = updater(currentValue);
            set(newValue); // use our custom set
        }
    };
}